import { ADD_CREDIT, CHARGE, REFUND, REFUND_CREDIT } from "./index";
import locale from './locale'
import React from 'react'
import moment from 'moment'

export const ClassOptionItem = (cls, currency = '')=>{
  return {
    value: cls.classID,
    label: (
      <div className='select-class'>
        <span>{cls.className}</span>
      </div>
    ),
  }
}

export default function(paymentType) {

  let paymentOptions = []

  if (paymentType !== REFUND && paymentType !== REFUND_CREDIT) {
    paymentOptions.push({
      label: __('Online Payment', locale), options: [
        { value: 'wechat_barcode_pay', label: __('WeChat Pay', locale) },
        { value: 'ali_barcode_pay', label: __('Alipay', locale) },
      ]
    });
  }

  paymentOptions.push({
    label: __('Transaction Record', locale),
    options: [
      { value: 'cash', label: __('Cash', 'PaymentModal') },
      { value: 'credit_card', label: __('Credit Card', 'PaymentModal') },
      { value: 'cheque', label: __('Cheque', 'PaymentModal') },
      { value: 'bank_transfer', label: __('Bank Transfer', 'PaymentModal') },
      { value: 'wechat_record_only', label: __('WeChat Pay Transfer', 'PaymentModal') },
      { value: 'ali_record_only', label: __('Alipay Transfer', 'PaymentModal') },
    ],
  });

  if (paymentType !== ADD_CREDIT && paymentType !== REFUND_CREDIT) {
    paymentOptions.push({ value: 'school_credit', label: __('School Credit', 'PaymentModal') });
  }

  let classOptions;
  if (this.props.classDetail) {
    classOptions = [ClassOptionItem(this.props.classDetail, currency)];
  } else {
    const classes = this.props.student.classList || [];
    classOptions = classes.map((cls)=>{
      return ClassOptionItem(cls, this.props.student.currency);
    });
  }

  switch(paymentType) {
  case ADD_CREDIT:
    return topupSchema.call(this, paymentOptions)
    break;
  case CHARGE:
    return chargeSchema.call(this, paymentOptions, classOptions)
    break;
  case REFUND:
    return refundSchema.call(this, paymentOptions, classOptions)
    break;
  case REFUND_CREDIT:
    return refundCreditSchema.call(this, paymentOptions, classOptions)
    break;
  }
}

function refundSchema(paymentOptions, classOptions) {
  const {currentClass, student, studentCreditInfo} = this.props;

  let usedPurchasedLabel;
  let lessonLabel;
  let lessonQuantityLabel;
  let fee;
  let currency = student.currency ? student.currency : studentCreditInfo.currency;

  if(currentClass.feeType == 0){
    usedPurchasedLabel = __('Term Rate', locale)
    lessonLabel = __('Term Rate', locale)
    fee = currentClass.classTotalFee
  } else if (currentClass.feeType == 1){
    usedPurchasedLabel = __('Used Lessons/Purchased Lessons', locale)
    lessonLabel = __('Lesson Rate', locale)
    fee = currentClass.unitPrice
    lessonQuantityLabel = __('Refund Lessons', locale)
  } else if (currentClass.feeType == 2){
    usedPurchasedLabel = __('Used Hours/Purchased Hours', locale)
    lessonLabel = __('Hour Rate', locale)
    fee = currentClass.unitPrice
    lessonQuantityLabel = __('Refund Hours', locale)
  }

	return [
    {
      name: 'class_id',
      label: __('Class', locale),
      type: 'reactSearch',
      required: true,
      options: classOptions,
      direction: 'down',
    },
    {
      type: 'customContent',
      content: (<div>
        <label className='control-label'>{usedPurchasedLabel}</label>
        <div>{currentClass.usedTotalQuantity + '/' + currentClass.paidTotalQuantity}</div>
      </div>),
      hidden: (!this.state.formData.class_id || currentClass.feeType === 0) ? true : false
    },
    {
      type: 'customContent',
      content: (<div>
        <label className='control-label'>{lessonLabel}</label>
        <div>{fee + ' ' + currency}</div>
      </div>),
      hidden: !this.state.formData.class_id ? true : false
    },
    {
      name: 'end_date',
      label: __('Refund Lesson Until...', locale),
      type: 'datePicker',
      hasEndDate: false,
      required: this.props.currentClass.feeType === 0 ? true : false,
      hidden: (!this.state.formData.class_id || currentClass.feeType !== 0) ? true : false
    },
    {
      name: 'lesson_quantity',
      label: lessonQuantityLabel,
      type: 'number',
      required: currentClass.feeType === 0 ? false : true,
      hidden: (!this.state.formData.class_id || currentClass.feeType === 0) ? true : false
    },
    {
      name: 'amount_of_money',
      label: __('Refund Amount', locale),
      type: 'money',
      required: true,
    },
    {
      name: 'trade_date',
      label: __('Refund Date', locale),
      type: 'datePicker',
      required: true,
    },
    {
      name: 'payment_method',
      label: __('Refund Methods', locale),
      type: 'reactSearch',
      required: true,
      options: paymentOptions,
      direction: 'up',
    },
  ]
}

function refundCreditSchema(paymentOptions, classOptions) {
	return [
    {
      name: 'amount_of_money',
      label: __('Refund Amount', locale),
      type: 'money',
      required: true,
    },
    {
      name: 'trade_date',
      label: __('Refund Date', locale),
      type: 'datePicker',
      required: true,
    },
    {
      name: 'payment_method',
      label: __('Refund Methods', locale),
      type: 'reactSearch',
      required: true,
      options: paymentOptions,
      direction: 'up',
    },
  ]
}

function chargeSchema(paymentOptions, classOptions) {
  let amountLabel;
  let lessonLabel;
  let tempPrice;
  let fixValue;

  if(this.props.currentClass.feeType == 0){
    amountLabel = __('Term Rate', locale)
    tempPrice = this.props.currentClass.classTotalFee
  } else if (this.props.currentClass.feeType == 1){
    amountLabel = __('Lesson Rate', locale)
    tempPrice = this.props.currentClass.unitPrice
    lessonLabel = __('Number of lessons', locale)
  } else if (this.props.currentClass.feeType == 2){
    amountLabel = __('Hour Rate', locale)
    tempPrice = this.props.currentClass.unitPrice
    lessonLabel = __('Number of hours', locale)
  }

  if(this.state.formData.amount_payable && this.props.currentClass.tuition_consumption === null){
    tempPrice = this.state.formData.amount_payable
  }

  let discountPrice = this.state.formData.discount_amount || 0
  let lessonQuantity = this.state.formData.lesson_quantity || 1

  return [
    {
      name: 'class_id',
      label: __('Class', locale),
      type: 'reactSearch',
      required: true,
      options: classOptions,
      direction: 'down',
    },
    {
      type: 'customContent',
      content: (<div>
        <label className='control-label'>{amountLabel}</label>
        {(tempPrice >= 0 && this.props.currentClass.tuition_consumption !== null) && <div>{this.state.formData.class_id ? tempPrice + ' ' + this.props.student.currency : ''}</div>}
        {(!tempPrice || this.props.currentClass.tuition_consumption === null) && <div style={{color: 'red'}}>{__('Setup', locale)}</div>}
      </div>),
      hidden: this.state.formData.class_id ? false : true
    },
    {
      name: 'lesson_quantity',
      label: lessonLabel,
      type: 'number',
      required: this.props.currentClass.feeType === 0 ? false : true,
      hidden: (!this.state.formData.class_id || this.props.currentClass.feeType === 0) ? true : false
    },
    {
      type: 'customContent',
      content : (<div>
        <label className='control-label'>{__('Total Price', locale)}</label>
        <div>{this.state.formData.class_id ? (tempPrice * lessonQuantity) + ' ' + this.props.student.currency : ''}</div>
      </div>),
      hidden: (this.state.formData.class_id && this.props.currentClass.tuition_consumption !== null) ? false : true
    },
    {
      name: 'end_date',
      label: __('Purchase Lesson Until...', locale),
      type: 'datePicker',
      hasEndDate: false,
      required: this.props.currentClass.feeType === 0 ? true : false,
      hidden: (!this.state.formData.class_id || this.props.currentClass.feeType !== 0) ? true : false
    },
    {
      name: 'amount_payable',
      label: __('Total Price', locale),
      type: 'money',
      required: false,
      hidden: (!this.state.formData.class_id || this.props.currentClass.tuition_consumption !== null) ? true : false
    },
    {
      name: 'discount_amount',
      label: __('Discount Price', locale),
      type: 'money',
      required: false,
    },
    {
      name: 'amount_of_money',
      label: __('Net Price', locale),
      type: 'money',
      fixValue: this.props.currentClass.tuition_consumption === null ? tempPrice - discountPrice : (tempPrice * lessonQuantity) - discountPrice,
      required: false,
      disabled: true,
      allowNegative: true
    },
  ]
}

function topupSchema(paymentOptions) {
  return [
    {
      name: 'amount_of_money',
      label: __('Top-up Amount', locale),
      type: 'money',
      required: true,
    },
    {
      name: 'trade_date',
      label: __('Top-up Date', locale),
      type: 'datePicker',
      required: true,
    },
    {
      name: 'payment_method',
      label: __('Payment Methods', locale),
      type: 'reactSearch',
      required: true,
      options: paymentOptions,
      direction: 'up',
    },
  ]
}



// WEBPACK FOOTER //
// ./src/template/Modals/NewPayment/schemaLeft.js